// extracted by mini-css-extract-plugin
export default {"container":"Ida-z","innerContainer":"Jda-z","multipleLines":"Kda-z","heading":"Lda-z","content":"Mda-z","linkColor":"Nda-z"};